module.exports = __webpack_public_path__ + "img/MIddle.8000b71e.png";